export default "__VITE_ASSET__CN9uuXs6__"